export function initAnnouncementBar() {
    'use strict';

    const container = document.querySelector('.announcement-bars-container');
    const header = document.querySelector('header.site-header');

    if (!container || !header) return;

    header.insertAdjacentElement('afterbegin', container);
}
